import { useQueryWithUserId } from '@northladder/services';

import { CUSTOMER_SERVICE_API } from '../customerServiceClient';
import { IFetchDeviceGradeConditionUrlOptions } from '../types';

/**
 * This is to track the DEVICE GRADE CONDITION in react query cache.
 */
export const DEVICE_GRADE_CONDITION_QUERY_KEY =
  'device-grade-condition-query-key';

/**
 * This hook fetches the Device Grade condition details using appraisalCode.
 */
export const useDeviceGradeConditionQuery = (
  queryParams: IFetchDeviceGradeConditionUrlOptions
) => {
  const { appraisalCode } = queryParams;

  const { data, isPending, isFetching, isError, error, refetch } =
    useQueryWithUserId({
      // eslint-disable-next-line @tanstack/query/exhaustive-deps
      queryKey: [DEVICE_GRADE_CONDITION_QUERY_KEY, appraisalCode],
      enabled: !!appraisalCode,
      queryFn: () =>
        CUSTOMER_SERVICE_API.fetchDeviceGradeConditions(queryParams),
    });

  return {
    data,
    error,
    isPending,
    isFetching,
    isError,
    refetch,
  };
};
